import { render, staticRenderFns } from "./OrgSaasDomainValidate.vue?vue&type=template&id=9e818364"
import script from "./OrgSaasDomainValidate.vue?vue&type=script&lang=js"
export * from "./OrgSaasDomainValidate.vue?vue&type=script&lang=js"
import style0 from "./OrgSaasDomainValidate.vue?vue&type=style&index=0&id=9e818364&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports